module.exports = __webpack_public_path__ + "static/media/background.2857ba11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background.png
// module id = 415
// module chunks = 0